import React, { useState, useRef, useEffect } from "react";
import {
  Box,
  Paper,
  Button,
  Typography,
  Stack,
  List,
  ListItem,
  ListItemText,
  Breadcrumbs,
  Link,
  Divider,
  // LinearProgress,
  // FormControl,
  // FormLabel,
  // RadioGroup,
  // Radio,
  // FormControlLabel,
  // Tooltip,
  // Checkbox,
  // CircularProgress,
} from "@mui/material";
import { renderAsync } from "docx-preview";

import {
  NavigateNextOutlined,
  Add as AddIcon,
  // Image as ImageIcon,
} from "@mui/icons-material";
// import mammoth from "mammoth";
import { allApis } from "../../request/config";
import apiRequest from "../../request/apiRequest/apiRequest";
import { useAppSelecter } from "../../hooks/storeHooks";
import { ObjectValues } from "../login";
import CustomSnackbar from "../../Components/CustomSnackbar/index";
import { type snackbarProps } from "../../Components/CustomSnackbar/index";

import { type structureProps } from "../../store/slices/constants/staticContents";
import mathFunction from "../exams/mathFunction";
import { ClusterType } from "../exams/bulkquestion/types";
import BulkQuestionsFormStepper from "../exams/bulkquestion/bulkQuestionStepper";
import FullScreenLoader from "../exams/bulkquestion/loader";
import { QuestionEditor } from "../exams/bulkquestion/QuestionEditor";
import { QuestionPreview } from "../exams/bulkquestion/QuestionPreview";
import CustomBreadcrumbsForMock from "../../Components/CustomBreadcrumbsForMock";
import { iconText } from "../../Components/CustomTexts";
import globalColors from "../../globalColors";

// interface ParsedQuestion {
//   id: string;
//   text: string;
//   options: {
//     text: string;
//     html: string;
//   }[];
//   correctAnswer: number;
//   explanation: string;
//   solutionHtml: string;
//   cluster: string;
//   tag?: string;
// }

interface Question {
  id: string;
  text: string;
  questionHtml: string;
  options: string[];
  correctAnswer: number;
  explanation: string;
  solutionHtml: string;
  image?: string;
  source?: string;
  tag?: string;
}

interface Cluster {
  id: string;
  name: string;
  questions: Question[];
}

// interface QuestionPayload {
//   question_: string;
//   option1: string;
//   option2: string;
//   option3: string;
//   option4: string;
//   correct_answer: string;
//   solution: string;
//   tag: string[];
// }

// interface ClusterPayload {
//   [cluster_name: string]: QuestionPayload[];
// }

export interface BulkQuestionsFormProps {
  dialogRef: React.MutableRefObject<{ onSubmitForm?: () => void }>;
  onSubmit: (questions: Question[]) => void;
  dockedCard: structureProps | null;
  onClose: () => void;
  section?: ObjectValues;
}

export default function BulkQuestionsForm({
  dialogRef,
  onSubmit,
  dockedCard,
  onClose,
  section,
}: BulkQuestionsFormProps) {
  const [clusters, setClusters] = useState<Cluster[]>([]);
  const [selectedClusterIndex, setSelectedClusterIndex] = useState(0);
  const [selectedQuestionIndex, setSelectedQuestionIndex] = useState(0);
  // const [editorElements, setEditorElements] = useState<NodeListOf<Element>>();
  const [hasFileUploaded, setHasFileUploaded] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  // const [dialogState, setDialogState] = useState<{
  //   open: boolean;
  //   type: "info" | "confirm";
  //   title: string;
  //   message: string;
  // }>({
  //   open: false,
  //   type: "confirm",
  //   title: "",
  //   message: "",
  // });
  // const [totalQuestions, setTotalQuestions] = useState(0);

  const userData = useAppSelecter(
    (state: ObjectValues) => state.userSlice.loggedUser
  );

  const ref = useRef<HTMLDivElement>();

  const fileInputRef = useRef<HTMLInputElement>(null);
  const [currentFileName, setCurrentFileName] = useState<String>("");
  // const questionListRefs = useRef<(HTMLDivElement | null)[]>([]);

  // const updateCompletedRef = useRef(false);
  const [clusterType, setClusterType] = useState<string | null>(null);
  const [hindiTranslation, setHindiTranslation] = useState<boolean>(false);

  const createEmptyQuestion = (): Question => ({
    id: Math.random().toString(36).substr(2, 9),
    text: "",
    questionHtml: "",
    options: ["", "", "", ""],
    correctAnswer: -1,
    explanation: "",
    solutionHtml: "",
  });

  const createEmptyCluster = (): ClusterType => ({
    id: Math.random().toString(36).substr(2, 9),
    name: `Cluster ${clusters.length + 1}`,
    questions: [createEmptyQuestion()],
  });

  const isValidQuestion = (question: Question) => {
    return (
      question.text.trim() !== "" &&
      question.options.length > 1 &&
      question.options.every((opt) => opt.trim() !== "") &&
      question.correctAnswer !== undefined &&
      question.correctAnswer >= 0 &&
      question.correctAnswer < question.options.length
    );
  };
  const getValidArray = (ques: any[]) => {
    const alMsg: string[] = [];
    const getMessage = (question: Question, index: number) => {
      let message = "";
      if (question.text.trim() === "") {
        message = `Question text is missing in Question ${index + 1}`;
      } else if (question.options.length !== 4) {
        message = `Options are missing in Question ${index + 1}`;
      } else if (question.options.some((opt) => opt.trim() === "")) {
        const missingIndexes = question.options
          .map((opt, i) =>
            opt.trim() === "" ? `Option ${String.fromCharCode(65 + i)}` : null
          )
          .filter(Boolean)
          .join(", ");
        message = `${missingIndexes} missing in Question ${index + 1}`;
      } else if (question.correctAnswer === undefined) {
        message = `Correct answer is not selected in Question ${index + 1}`;
      } else if (
        question.correctAnswer < 0 ||
        question.correctAnswer >= question.options.length
      ) {
        message = `Correct answer index is invalid in Question ${index + 1}`;
      }

      return message;
    };
    const fArray = ques.filter((question, index) => {
      if (
        !(
          question.text.trim() !== "" &&
          question.options.length > 1 &&
          question.options.every((opt: any) => opt.trim() !== "") &&
          question.correctAnswer !== undefined &&
          question.correctAnswer >= 0 &&
          question.correctAnswer < question.options.length
        )
      ) {
        alMsg.push(getMessage(question, index));
      }
      return (
        question.text.trim() !== "" &&
        question.options.length > 1 &&
        question.options.every((opt: any) => opt.trim() !== "") &&
        question.correctAnswer !== undefined &&
        question.correctAnswer >= 0 &&
        question.correctAnswer < question.options.length
      );
    });
    if (fArray.length !== ques.length) {
      setErr({
        open: true,
        message: alMsg.join(","),
        severity: "error",
      });
    }
  };

  const handleClusterTypeChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setClusterType(event.target.value);
  };

  // const handleHindiTranslation = () => {
  //   setHindiTranslation((prev) => !prev);
  // };
  const [times, setTime] = useState({ min: "", max: "" });

  const isSingleQuestionPerCluster = () => {
    return clusters.every(
      (cluster) => cluster.questions.filter(isValidQuestion).length === 1
    );
  };

  // const handleOpen = () => {
  //   if (isSingleQuestionPerCluster()) {
  //     setDialogState({
  //       open: true,
  //       type: "info",
  //       title: "Already Separated",
  //       message:
  //         "Questions are already organized with one question per cluster.",
  //     });
  //   } else {
  //     setDialogState({
  //       open: true,
  //       type: "confirm",
  //       title: "Confirmation",
  //       message: `This will replace existing clusters and create a total of ${countTotalQuestions()} clusters (one cluster per question). Do you want to continue?`,
  //     });
  //   }
  // };

  // const handleClose = () => {
  //   setDialogState((prev) => ({ ...prev, open: false }));
  // };

  const countTotalQuestions = () => {
    return clusters.reduce((total, cluster) => {
      return total + cluster.questions.filter(isValidQuestion).length;
    }, 0);
  };

  const handleConfirmSingleQuestion = () => {
    const allQuestions = clusters.flatMap((cluster) =>
      cluster.questions.filter(isValidQuestion)
    );

    const newClusters = allQuestions.map((question, index) => ({
      id: Math.random().toString(36).substr(2, 9),
      name: `Cluster ${index + 1}`,
      questions: [question],
    }));

    setClusters(newClusters);
    setSelectedClusterIndex(0);
    setSelectedQuestionIndex(0);
    // handleClose();
  };

  const getAbsoluteQuestionIndex = (
    clusterIndex: number,
    questionIndex: number
  ) => {
    return (
      clusters.slice(0, clusterIndex).reduce((sum, cluster) => {
        const validQuestions = cluster.questions.filter(
          (question) => question.text.trim() !== ""
        );
        return sum + validQuestions.length;
      }, 0) + questionIndex
    );
  };
  const scrollAllSections = (absoluteQuestionIndex: number) => {
    // setTimeout(() => {
    //   const scrollOptions = {
    //     behavior: "smooth" as ScrollBehavior,
    //     block: "start" as ScrollLogicalPosition,
    //   };
    //   const editorRef = editorRefs.current[absoluteQuestionIndex];
    //   const previewElements = Array.from(
    //     document.querySelectorAll(".preview-question-box")
    //   );
    //   const previewRef =
    //     previewElements[selectedClusterIndex - selectedQuestionIndex] ||
    //     previewElements[absoluteQuestionIndex - 1];
    //   if (editorRef) {
    //     editorRef.scrollIntoView(scrollOptions);
    //   }
    //   if (previewRef) {
    //     previewRef.scrollIntoView(scrollOptions);
    //   }
    //   setTimeout(() => {
    //     const questionTextField =
    //       inputRefs.current[
    //         `question-text-${selectedClusterIndex}-${selectedQuestionIndex}`
    //       ];
    //     if (questionTextField) {
    //       questionTextField.focus();
    //     }
    //   }, 100);
    // }, 0);
  };

  useEffect(() => {
    setClusters([createEmptyCluster()]);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const absoluteIndex = getAbsoluteQuestionIndex(
      selectedClusterIndex,
      selectedQuestionIndex
    );
    scrollAllSections(absoluteIndex);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedQuestionIndex, selectedClusterIndex]);

  useEffect(() => {
    if (clusters[selectedClusterIndex]?.questions[selectedQuestionIndex]) {
      const questionTextElement = document.getElementById(
        `question-text-${selectedClusterIndex}-${selectedQuestionIndex}`
      );
      if (questionTextElement) {
        questionTextElement.focus();
      }
    }
  }, [selectedClusterIndex, selectedQuestionIndex, clusters]);


  const replaceBase64WithUploadedUrl = (
    htmlContent: string,
    imgMap: Record<string, string>
  ): string => {
    let processedHtml = htmlContent;

    // Process each base64 image and its uploaded URL
    for (const [base64Image, uploadedUrl] of Object.entries(imgMap)) {
      try {
        // Instead of using regex with the base64 string directly, which can contain regex special chars,
        // we'll use a safer approach by creating a DOM parser and replacing nodes
        const parser = new DOMParser();
        const doc = parser.parseFromString(processedHtml, "text/html");
        const imgElements = doc.getElementsByTagName("img");

        // Check each image element to see if it matches our base64 string
        for (const img of Array.from(imgElements)) {
          const src = img.getAttribute("src");
          if (src === base64Image) {
            img.setAttribute("src", uploadedUrl);
            img.setAttribute("width", "100%");
          }
        }

        // Convert back to string
        processedHtml = doc.body.innerHTML;
      } catch (error) {
        console.error("Error replacing base64 with uploaded URL:", error);
      }
    }

    return processedHtml;
  };

  const base64ToBlob = (base64Data: string, fileName: string): File => {
    const [header, content] = base64Data.split(",");
    const mimeMatch = header.match(/^data:(.*?);/);
    const mimeType = mimeMatch ? mimeMatch[1] : "image/png";

    const binaryStr = window.atob(content);
    const len = binaryStr.length;
    const arr = new Uint8Array(len);

    for (let i = 0; i < len; i++) {
      arr[i] = binaryStr.charCodeAt(i);
    }

    const blob = new Blob([arr], { type: mimeType });
    return new File([blob], fileName, { type: mimeType });
  };
  const convertImageToBase64 = async (blobUrl: string): Promise<string> => {
    const response = await fetch(blobUrl);
    let blob = await response.blob();

    // Force correct MIME type
    if (!blob.type.startsWith("image/")) {
      blob = new Blob([blob], { type: "image/png" });
    }

    // Convert Blob to HTMLImageElement
    const image = await new Promise<HTMLImageElement>((resolve, reject) => {
      const img = new Image();
      img.onload = () => resolve(img);
      img.onerror = reject;
      img.src = URL.createObjectURL(blob);
    });

    // Create a canvas and resize (adjust as needed)
    const canvas = document.createElement("canvas");
    const MAX_WIDTH = 400; // You can adjust this
    const scaleFactor = MAX_WIDTH / image.width;
    canvas.width = MAX_WIDTH;
    canvas.height = image.height * scaleFactor;

    const ctx = canvas.getContext("2d");
    ctx?.drawImage(image, 0, 0, canvas.width, canvas.height);

    // Compress to JPEG, reduce quality if needed (0.5 = 50%)
    const base64 = canvas.toDataURL("image/jpeg", 0.5); // Try 0.3 for smaller size

    // Clean up
    URL.revokeObjectURL(image.src);

    return base64;
  };

  const processHtmlWithImageRestrictions = async (html: string) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");
    const imgElements = doc.getElementsByTagName("img");
    const uploadedImgMap: Record<string, string> = {};

    for (const img of Array.from(imgElements)) {
      const src: any = img.getAttribute("src");
      //  const response = await fetch( src);
      // const blob = await response.blob(); // ✅ this is a Blob
      const base64Image: any = await convertImageToBase64(src);
      // await blobToDataURL(blob)
      if (base64Image && base64Image.startsWith("data:image")) {
        try {
          const mimeMatch = await base64Image.match(
            /^data:image\/(png|jpeg|jpg|gif);base64,/
          );
          const fileExtension = mimeMatch ? mimeMatch[1] : "png";
          const now = new Date();
          const formattedDate = `${now.getFullYear()}${String(
            now.getMonth() + 1
          ).padStart(2, "0")}${String(now.getDate()).padStart(2, "0")}${String(
            now.getHours()
          ).padStart(2, "0")}${String(now.getMinutes()).padStart(
            2,
            "0"
          )}${String(now.getSeconds()).padStart(2, "0")}`;
          const fileName = `${formattedDate}.${fileExtension}`;

          const imageFile = base64ToBlob(base64Image, fileName);
          const res = await apiRequest({
            form: true,
            api: allApis.file_upload,
            payload: {
              parent_id: selectedClusterIndex,
              file: imageFile,
              filename: fileName,
              created_by: userData?.id,
              modified_by: userData?.id,
              parent_model: selectedQuestionIndex,
            },
          });
          if (res.file) {
            uploadedImgMap[src] = res.file;
          }
        } catch (error) {
          console.error("Upload error:", error);
        }
      }
    }

    return uploadedImgMap;
  };
  const removeIncompleteTags = (htmlContent: string) => {
    // // Remove empty or self-closing <p> and <span> tags
    // htmlContent = htmlContent.replace(/<p[^>]*>\s*<\/p>/gi, "");
    // htmlContent = htmlContent.replace(/<span[^>]*>\s*<\/span>/gi, "");

    // Remove orphaned opening <p> or <span> tags without closing counterparts
    htmlContent = htmlContent.replace(/<p[^>]*>(?![\s\S]*<\/p>)/gi, "");
    htmlContent = htmlContent.replace(/<span[^>]*>(?![\s\S]*<\/span>)/gi, "");

    // Remove orphaned closing </p> or </span> tags without opening counterparts
    htmlContent = htmlContent.replace(/<\/p>(?![\s\S]*<p[^>]*>)/gi, "");
    htmlContent = htmlContent.replace(/<\/span>(?![\s\S]*<span[^>]*>)/gi, "");

    // // Remove any remaining `<br>` or `<undefined>` tags
    // htmlContent = htmlContent.replace(/<\/?br\s*\/?>/gi, "");
    // htmlContent = htmlContent.replace(/<\/?undefined>/gi, "");

    // Trim and normalize whitespace
    return htmlContent.trim().replace(/\s+/g, " ");
  };
  const addMarginToPTags = (htmlString: any) => {
    const container = document.createElement("div");
    container.innerHTML = htmlString;

    const pTags = container.querySelectorAll("p");

    pTags.forEach((p) => {
      const computedStyle = window.getComputedStyle(p);
      const marginBottom = parseFloat(computedStyle.marginBottom);

      if (!p.style.marginBottom || marginBottom === 0) {
        p.style.marginBottom = "10pt";
      }
    });

    return container.innerHTML;
  };
  const parseQuestionContent = (
    questionContent: string,
    uploadedImgMap: Record<string, string>,
    stylesString: string
  ): Partial<Question> => {
    const question: Partial<Question> = {
      id: Math.random().toString(36).substr(2, 9),
      options: [],
      solutionHtml: "",
      explanation: "",
      questionHtml: "",
    };

    // // Helper function to balance HTML tags
    // const balanceHtmlTags = (content: string): string => {
    //   if (!content) return "";

    //   // Remove closing tags at start without opening tags
    //   let cleaned = content.replace(/^(\s*<\/[^>]+>)+/, "");
    //   // cleaned = cleaned.replace(/<([a-z][a-z0-9]*)\b[^>]*>(?![\s\S]*<\/\1>)/gi, "");
    //   // Track opening and closing tags
    //   cleaned = cleaned.replace(/<(span|p)\b[^>]*>(?![\s\S]*<\/\1\s*>)/gi, "");

    //   const openTags: string[] = [];
    //   const tagPattern = /<\/?([a-z][a-z0-9]*)\b[^>]*>/gi;
    //   let match;

    //   // Find all tags and track them
    //   while ((match = tagPattern.exec(cleaned)) !== null) {
    //     const fullTag = match[0];
    //     const tagName = match[1].toLowerCase();

    //     if (!fullTag.includes("/>") && !fullTag.includes("</")) {
    //       // Opening tag
    //       openTags.push(tagName);
    //     } else if (fullTag.startsWith("</")) {
    //       // Closing tag
    //       if (openTags.includes(tagName)) {
    //         // Remove the last matching opening tag
    //         const index = openTags.lastIndexOf(tagName);
    //         openTags.splice(index, 1);
    //       }
    //     }
    //   }

    //   // Add missing opening tags at start
    //   let prefix = "";
    //   const seenClosingTags = new Set();
    //   const closingTagPattern = /<\/([a-z][a-z0-9]*)\b[^>]*>/gi;

    //   while ((match = closingTagPattern.exec(cleaned)) !== null) {
    //     const tagName = match[1].toLowerCase();
    //     if (!seenClosingTags.has(tagName) && !cleaned.includes(`<${tagName}`)) {
    //       prefix += `<${tagName}>`;
    //       seenClosingTags.add(tagName);
    //     }
    //   }

    //   // Add missing closing tags at end
    //   const suffix = openTags
    //     .reverse()
    //     .map((tag) => `</${tag}>`)
    //     .join("");

    //   return prefix + cleaned + suffix;
    // };
    // const balanceHtmlTags = (content: string): string => {
    //   if (!content) return "";

    //   // Remove orphaned closing tags at the start
    //   let cleaned = content.replace(/^(\s*<\/[^>]+>)+/, "");

    //   // // Remove trailing <br> tags to prevent excess line breaks
    //   // cleaned = cleaned.replace(/(<br\s*\/?>)+$/gi, "");

    //   // Remove unclosed <span> and <p> tags
    //   cleaned = cleaned.replace(/<(span|p)\b[^>]*>(?![\s\S]*<\/\1\s*>)/gi, "");

    //   const openTags: string[] = [];
    //   const tagPattern = /<\/?([a-z][a-z0-9]*)\b[^>]*>/gi;
    //   let match;

    //   // Track opening and closing tags
    //   while ((match = tagPattern.exec(cleaned)) !== null) {
    //     const fullTag = match[0];
    //     const tagName = match[1].toLowerCase();

    //     // Ignore self-closing tags like <br>
    //     if (fullTag.endsWith("/>")) continue;

    //     if (!fullTag.startsWith("</")) {
    //       openTags.push(tagName);
    //     } else {
    //       const index = openTags.lastIndexOf(tagName);
    //       if (index !== -1) {
    //         openTags.splice(index, 1);
    //       }
    //     }
    //   }

    //   // Add missing closing tags at the end
    //   const suffix = openTags
    //     .reverse()
    //     .filter((s) => s !== "br")
    //     .map((tag) => `</${tag}>`)
    //     .join("");

    //   // Remove excessive <br> tags at the end
    //   // .replace(/(<br\s*\/?>)+$/gi, "")
    //   return (cleaned + suffix).trim();
    // };
    const balanceHtmlTags = (content: string): string => {
      if (!content) return "";

      // Step 1: Remove orphaned closing tags at the very beginning
      let cleaned = content.replace(/^(\s*<\/[^>]+>)+/, "");

      const tagPattern = /<\/?([a-z][a-z0-9]*)\b[^>]*>/gi;
      const openTags: { tag: string; index: number }[] = [];
      let match;

      // Step 2: Track unmatched opening tags
      while ((match = tagPattern.exec(cleaned)) !== null) {
        const fullTag = match[0];
        const tagName = match[1].toLowerCase();

        // Skip self-closing tags
        if (fullTag.endsWith("/>")) continue;

        if (!fullTag.startsWith("</")) {
          openTags.push({ tag: tagName, index: match.index });
        } else {
          // Match closing tag with the most recent opening tag
          const index = openTags.map((t) => t.tag).lastIndexOf(tagName);
          if (index !== -1) {
            openTags.splice(index, 1);
          } else {
            // Unmatched closing tag, remove it
            cleaned =
              cleaned.slice(0, match.index) +
              cleaned.slice(tagPattern.lastIndex);
            tagPattern.lastIndex = match.index; // reset to re-scan after removal
          }
        }
      }

      // Step 3: Append closing tags for any unclosed opening tags
      const closingTags = openTags
        .reverse()
        .filter((t) => t.tag !== "br")
        .map((t) => `</${t.tag}>`)
        .join("");

      return (cleaned + closingTags).trim();
    };

    try {
      const normalizedContent = questionContent;

      // Extract question text while preserving formatting
      const questionTextMatch = normalizedContent.match(
        /^\s*(.*?)(?=Tag:|Options:)/s
      );

      if (questionTextMatch) {
        // `<style>${stylesString}</style>\n` +
        const extractedText = removeIncompleteTags(questionTextMatch[1].trim());

        question.text = extractedText.replace(/<[^>]+>/g, "").trim();
        question.questionHtml = balanceHtmlTags(extractedText);
      }

      // Extract optional tag
      const tagMatch = normalizedContent.match(
        /Tag:\s*([^]*?)(?=Options:|[\d\(][\.|\)])/i
      );
      const removePTagsAndStyling = (htmlString: any) => {
        // Create a DOM parser
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlString, "text/html");

        // Remove all <p> and <span> tags
        const tagsToRemove = ["p", "span"];
        tagsToRemove.forEach((tag) => {
          const elements = doc.querySelectorAll(tag);
          elements.forEach((el) => {
            const parent: any = el.parentNode;
            while (el.firstChild) {
              parent.insertBefore(el.firstChild, el);
            }
            parent.removeChild(el);
          });
        });

        // Remove inline styles
        const elementsWithStyle = doc.querySelectorAll("[style]");
        elementsWithStyle.forEach((el) => el.removeAttribute("style"));

        return doc.body.innerHTML;
      };

      if (tagMatch) {
        question.tag = removePTagsAndStyling(removeIncompleteTags(tagMatch[1]))
          .replace(/<[^>]+>/g, "")
          .trim();
      }
      // Extract options
      let optionsText = removeIncompleteTags(
        normalizedContent.match(
          /Options:.*?(?=Correct(?:\s*Answer:|[\s\n]*<strong>\s*Answer<\/strong>:|[\s\n]*Answer:)|$)/is
        )?.[0] || ""
      );
      // Handle list items in options
      const listItems = optionsText.match(/<li>(.*?)<\/li>/g);
      if (listItems) {
        const optionLetters = ["a", "b", "c", "d"];
        listItems.forEach((item, idx) => {
          const cleanItem = item.replace(/<\/?li>/g, "").trim();
          optionsText = removePTagsAndStyling(optionsText).replace(
            item,
            `(${optionLetters[idx]}) ${cleanItem}`
          );
        });
      }
      const truncatedText = optionsText.split(
        /<[^>]*>\s*Correct\s*<[^>]*>\s*Answer|Correct\s*Answer|Correct\s*Option/i
      )[0];

      // Extract and format options
      const optionsMatch = truncatedText.match(
        /\(([a-d])\)(.*?)(?=\([a-d]\)|$)/g
      );
      //   const optionsMatch =
      //  /\(?([a-d])\)?[\).]*\s*(.*?)(?=\(?[a-d]\)?[\).]*|$)/g
      //   console.log(optionsMatch,optionsText,"optionsMatch")

      if (optionsMatch) {
        question.options = optionsMatch.slice(0, 4).map((opt, index) => {
          // let optionText = opt.replace(/^\([a-d]\)/, "").trim();
          let optionText = opt.replace(/^\([a-d]\)[\s]*/, "").trim();
          optionText = balanceHtmlTags(optionText);

          optionText = replaceBase64WithUploadedUrl(optionText, uploadedImgMap);

          return optionText;
        });
      }
      if (optionsMatch === null || optionsMatch.length !== 4) {
        const optionsMatch3 = truncatedText.match(
          /([a-d]\s*\)|\(\s*[a-d]\s*\))\s*((?:(?![a-d]\s*\)|\(\s*[a-d]\s*\))).)+/gis
        );

        //   const optionsMatch3 =
        //  /\(?([a-d])\)?[\).]*\s*(.*?)(?=\(?[a-d]\)?[\).]*|$)/g
        //   console.log(optionsMatch3,optionsText,"optionsMatch3")

        if (optionsMatch3) {
          question.options = optionsMatch3.slice(0, 4).map((opt, index) => {
            // let optionText = opt.replace(/^\([a-d]\)/, "").trim();
            let optionText = opt
              .replace(/^(?:\(\s*[a-d]\s*\)|[a-d]\s*\))\s*/, "")
              .trim();

            optionText = balanceHtmlTags(optionText);

            optionText = replaceBase64WithUploadedUrl(
              optionText,
              uploadedImgMap
            );

            return optionText;
          });
        }
      } else {
      }
      console.log(question.options, "question.options");
      if (!question.options || question.options.length !== 4) {
      }
      const correctAnswerMatch = normalizedContent.match(
        /Correct(?:<[^>]*>|\s)*Answer(?:<[^>]*>|\s)*:?(?:<[^>]*>|\s)*\(?(?:<[^>]*>|\s)*([A-Da-d])(?:<[^>]*>|\s)*\)?/i
      );

      // .match(
      //       /(?:Correct\s*Answer|Answer)\s*:?\s*(?:<[^>]*>\s*)*\(([a-d])\)/i
      //     );
      if (correctAnswerMatch) {
        question.correctAnswer =
          correctAnswerMatch[1].toLowerCase().charCodeAt(0) - 97;
      } else {
      }
      const solutionMatch = normalizedContent.match(
        /(?:Solution:|<strong>Solution:<\/strong>)(.*)$/s
      );
      if (solutionMatch) {
        const extractedSolution = solutionMatch[1].trim();
        question.solutionHtml = balanceHtmlTags(extractedSolution); // const splitByTagClose = (input: string, maxLength = 2000): string[] => {
        //   const chunks: string[] = [];
        //   let start = 0;

        //   while (start < input.length) {
        //     const maxEnd = Math.min(start + maxLength, input.length);
        //     let lastTagEnd = -1;

        //     const sub = input.slice(start, maxEnd);
        //     const closingTagRegex = /<\/[^>]+>/g;

        //     let match: RegExpExecArray | null;
        //     while ((match = closingTagRegex.exec(sub)) !== null) {
        //       lastTagEnd = match.index + match[0].length;
        //     }

        //     // If we found a safe closing tag point within the limit
        //     if (lastTagEnd !== -1) {
        //       chunks.push(sub.slice(0, lastTagEnd));
        //       start += lastTagEnd;
        //     } else {
        //       // No closing tag found, hard cut (last resort)
        //       chunks.push(sub);
        //       start = maxEnd;
        //     }
        //   }

        //   return chunks;
        // };

        // console.log(
        //   sr.length,
        //   splitByTagClose(`${sr}`),
        //   splitByTagClose(`${sr}`).join("").length
        // );
      }

      if (question.questionHtml) {
        question.questionHtml = replaceBase64WithUploadedUrl(
          question.questionHtml,
          uploadedImgMap
        );
      }
      if (question.solutionHtml) {
        question.solutionHtml = replaceBase64WithUploadedUrl(
          question.solutionHtml,
          uploadedImgMap
        );
      }
    } catch (error) {
      console.error("Error parsing question content:", error);
    }

    return question;
  };

  const hiddenContainerRef: any = useRef<HTMLDivElement>(null);
  const handleFileUpload = async (
    event: React.ChangeEvent<HTMLInputElement>,
    clusterIndex?: number
  ) => {
    const file = event.target.files?.[0];
    if (!file) return;

    setCurrentFileName(file.name);
    setIsUploading(true);
    setUploadProgress(0);
    setHasFileUploaded(true);

    const reader = new FileReader();
    reader.onload = async (e) => {
      try {
        const progressInterval = setInterval(() => {
          setUploadProgress((prev) => {
            if (prev >= 90) {
              clearInterval(progressInterval);
              return 90;
            }
            return prev + 10;
          });
        }, 200);

        // const result = await mammoth.convertToHtml({
        //   arrayBuffer: e.target?.result as ArrayBuffer,
        // });
        const arrayBuffer = e.target?.result as ArrayBuffer;

        // Clear existing content
        hiddenContainerRef.current.innerHTML = "";

        // Render docx into hidden div
        await renderAsync(arrayBuffer, hiddenContainerRef.current);

        // Extract HTML as string
        const renderedHTML = hiddenContainerRef.current.innerHTML;
        let htmlContent: any = renderedHTML
          .replace(/\*\*/g, "")
          // .replace(/<p>/g, '<p class="docx-text">')
          // .replace(/font-family:\s*["']?[^;"']*["']?;?/gi, "")
          // .replace(/font-size:\s*["']?[^;"']*["']?;?/gi, "")
          // .replace(/font-family:\s*["']?[^;"']*["']?;?/gi, "")
          // .replace(/font-size:\s*["']?[^;"']*["']?;?/gi, "")
          // .replace(/font-family:\s*["']?[^;"']*["']?;?/gi, "")  // Remove font-family
          // .replace(/font-size:\s*["']?[^;"']*["']?;?/gi, "")   // Remove font-size
          // .replace(/\s*;$/g, "")  // Remove trailing semicolon if it's left behind
          // .replace(/\s{2,}/g, ' ') // Remove any multiple spaces

          .replace(/<li>/g, '<li class="docx-text">')
          .trim();
        // console.log(htmlContent,"htmlContent")
        const extractStylesFromHtml = (htmlContent: string): string => {
          const styleRegex = /<style[^>]*>([\s\S]*?)<\/style>/gi;
          const matches = [];
          let match;

          while ((match = styleRegex.exec(htmlContent)) !== null) {
            matches.push(match[1]); // Only the inside of the <style>...</style>
          }

          return matches.join("\n"); // combine all style blocks into one string
        };

        const stylesString = extractStylesFromHtml(htmlContent);
        htmlContent.replace(/&quot;/g, '"');

        // Remove font-family and font-size properties
        htmlContent = htmlContent
          .replace(/font-family:\s*["']?[^;"']*["']?;?/gi, "") // Remove font-family
          .replace(/font-size:\s*["']?[^;"']*["']?;?/gi, "") // Remove font-size
          .replace(/color:\s*["']?[^;"']*["']?;?/gi, "") // Remove color
          .replace(/font-family:\s*['"]?Times New Roman['"]?;?/gi, "")
          .replace(/Times New Roman&quot;;/g, "")
          .replace(/\s*;$/g, ""); // Remove any trailing semicolon // Remove any multiple spaces
        const refactorImageAlignment = (htmlString: any) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(htmlString, "text/html");

          const imgDivs = doc.querySelectorAll("div > img");

          imgDivs.forEach((img) => {
            const div: any = img.parentElement;
            const prevP = div.previousElementSibling;

            if (prevP && prevP.tagName.toLowerCase() === "p") {
              const textAlign = prevP.style.textAlign;

              if (textAlign) {
                div.style.width = "100%";
                div.style.display = "flex";

                if (textAlign === "center") {
                  div.style.justifyContent = "center";
                } else if (textAlign === "right") {
                  div.style.justifyContent = "flex-end";
                } else {
                  div.style.justifyContent = "flex-start";
                }

                prevP.style.textAlign = "";
              }
            }
          });

          return doc.body.innerHTML;
        };
        const adjustEmptyPTags = (htmlContent: any) => {
          htmlContent.replace(
            /<p\s+style="([^"]*?margin-bottom: 10pt[^"]*?)"><\/p>/g,
            '<p style="min-height: 1px; max-height: 1px">&nbsp;</p>'
          );
          htmlContent = htmlContent.replace(
            /<p\s+style="([^"]*?margin-bottom: 10pt[^"]*?)"><\/p>/g,
            '<p style="min-height: 1px; max-height: 1px">&nbsp;</p>'
          );

          // Replace <p> tags with empty <span> or <div> tags (with or without styles)
          htmlContent = htmlContent.replace(
            /<p\s+style="([^"]*?margin-bottom: 10pt[^"]*?)">(?:<(?:span|div)\s*[^>]*?>\s*<\/(?:span|div)>)*<\/p>/g,
            '<p style="min-height: 1px; max-height: 1px">&nbsp;</p>'
          );
          return htmlContent;
        };
        htmlContent = addMarginToPTags(refactorImageAlignment(htmlContent));
        htmlContent = adjustEmptyPTags(htmlContent);

        const uploadedImgMap = await processHtmlWithImageRestrictions(
          htmlContent
        );
        const clusterNumbers = htmlContent.match(/Cluster (\d+\.\d+)/g) || [];
        let newClusters: Cluster[] = [];

        if (clusterNumbers.length > 0) {
          // Handle content with explicit clusters
          const sections = htmlContent.split(/Cluster \d+\.\d+/);
          clusterNumbers.forEach((clusterHeader: string, index: number) => {
            const clusterMatch = clusterHeader.match(/Cluster (\d+\.\d+)/);
            if (!clusterMatch) return;

            const clusterNumber = clusterMatch[1];
            const clusterContent = sections[index + 1];
            if (!clusterContent) return;

            const cluster = processClusterContent(
              clusterContent,
              clusterNumber,
              uploadedImgMap,
              stylesString
            );
            getValidArray(cluster.questions);
            if (cluster.questions.length > 0) {
              newClusters.push(cluster);
            }
          });
        } else {
          // Handle content without clusters - create a default cluster
          const defaultCluster = processClusterContent(
            htmlContent,
            "1",
            uploadedImgMap,
            stylesString
          );
          if (defaultCluster.questions.length > 0) {
            newClusters = [defaultCluster];
          }
        }

        setClusters(newClusters);
        setSelectedClusterIndex(clusterIndex || 0);
        setSelectedQuestionIndex(0);

        clearInterval(progressInterval);
        setUploadProgress(100);
        setTimeout(() => {
          setIsUploading(false);
          setUploadProgress(0);
        }, 1000);
      } catch (error) {
        setIsUploading(false);
        setUploadProgress(0);
      }
    };
    reader.readAsArrayBuffer(file);
  };

  const handleSmartPaste = (event: React.ClipboardEvent<HTMLDivElement>) => {
    event.preventDefault();
    const text = event.clipboardData.getData("text");

    const cleanText = text.replace(/\*\*/g, "").replace(/\*/g, "");

    const newQuestion: Partial<Question> = {
      id: Math.random().toString(36).substr(2, 9),
      options: [],
      solutionHtml: "",
      explanation: "",
      questionHtml: "",
    };

    const questionMatch = cleanText.match(
      /Question\s*\d+\.\s*(.*?)(?=Options:)/s
    );
    if (questionMatch) {
      newQuestion.text = questionMatch[1].trim();
      newQuestion.questionHtml = `<p>${newQuestion.text}</p>`;
    }

    const optionsText =
      cleanText.match(/Options:.*?(?=Correct Answer:|$)/s)?.[0] || "";
    const optionsMatch = optionsText.match(/\([a-d]\)[^()]+/gi);

    if (optionsMatch) {
      newQuestion.options = optionsMatch.map((opt) =>
        opt.replace(/^\([a-d]\)/, "").trim()
      );
    }

    const correctAnswerMatch = cleanText.match(
      /Correct Answer:\s*\(([a-d])\)/i
    );
    if (correctAnswerMatch) {
      newQuestion.correctAnswer =
        correctAnswerMatch[1].toLowerCase().charCodeAt(0) - 97;
    } else {
    }

    const solutionMatch = cleanText.match(
      /Solution:(.*?)(?=\(this is my question|$)/s
    );
    if (solutionMatch) {
      const solutionText = solutionMatch[1].trim();
      newQuestion.explanation = solutionText;

      const solutionLines = solutionText
        .split("\n")
        .map((line) => line.trim())
        .filter(Boolean);

      let solutionHtml = "<div>";
      let inList = false;

      solutionLines.forEach((line) => {
        if (line.startsWith("*")) {
          if (!inList) {
            solutionHtml += "<ul>";
            inList = true;
          }
          const bulletPoint = line.substring(1).trim();
          solutionHtml += `<li>${bulletPoint}</li>`;
        } else {
          if (inList) {
            solutionHtml += "</ul>";
            inList = false;
          }
          solutionHtml += `<p>${line}</p>`;
        }
      });

      if (inList) {
        solutionHtml += "</ul>";
      }
      solutionHtml += "</div>";

      newQuestion.solutionHtml = solutionHtml;
    }

    if (
      newQuestion.text &&
      Array.isArray(newQuestion.options) &&
      newQuestion.options.length > 0 &&
      newQuestion.correctAnswer !== undefined
    ) {
      clusters[selectedClusterIndex].questions[
        clusters[selectedClusterIndex].questions.length - 1
      ] = newQuestion as Question;
      addNewQuestion(selectedClusterIndex);
    }
  };

  const processClusterContent = (
    content: string,
    clusterNumber: string,
    uploadedImgMap: Record<string, string>,
    stylesString: string
  ): Cluster => {
    const cluster: Cluster = {
      id: Math.random().toString(36).substr(2, 9),
      name: `Cluster ${clusterNumber}`,
      questions: [],
    };
    // const questionSegments = content.split(/Question \d+\./);
    const questionSegments = content.split(
      /(?:<[^>]+>)*Question\s*(?:<[^>]+>)*\d+(?:<[^>]+>)*\./gi
    );

    // const questionSegments = content.split(
    //   /(?=<span[^>]*>Question<\/span>\s*<span[^>]*>[^<]+<\/span>|Question\s+\S+\.?)/i
    // );

    // console.log(content,"content")
    //     const questionSegments = content.split(
    //   /(?:^|\n|\r)(?=(?:<span[^>]*>\s*Question\s*<\/span>\s*<span[^>]*>\s*\d+\.?\s*<\/span>)|(?:Question\s+\d+\.?))/gi
    // );

    const questions = questionSegments.filter((q) => q.trim());

    questions.forEach((questionContent, index) => {
      const question = parseQuestionContent(
        questionContent,
        uploadedImgMap,
        stylesString
      );

      if (
        question.text &&
        question.options?.length === 4 &&
        question.correctAnswer !== undefined
      ) {
        // let temp = {
        //   question_: question.text,
        //   option1: question.options[0],
        //   option2: question.options[1],
        //   option3: question.options[2],
        //   option4: question.options[3],
        //   correctAnswer: `option${question.correctAnswer + 1}`,
        //   solution: question.solutionHtml,
        //   tag: question.tag
        //     ? question.tag.split(",").map((tag) => tag.trim())
        //     : [],
        // };
        cluster.questions.push(question as Question);
      } else if (question.text) {
        setErr({
          open: true,
          message:
            question.options?.length !== 4
              ? `Options Missing in Question ${index + 1}`
              : question.correctAnswer === undefined
              ? `Correct Answer Missing in Question ${index + 1}`
              : "",
          severity: "error",
        });
      } else {
      }
    });

    return cluster;
  };

  const addNewCluster = () => {
    setClusters((prev) => [...prev, createEmptyCluster()]);
    setSelectedClusterIndex(clusters.length);
    setSelectedQuestionIndex(0);
  };

  const addNewQuestion = (clusterIndex: number) => {
    const lastQuestion =
      clusters[clusterIndex].questions[
        clusters[clusterIndex].questions.length - 1
      ];

    if (
      !lastQuestion ||
      !lastQuestion.text.trim() ||
      !lastQuestion.options.some((opt) => opt)
    ) {
      alert(
        "The last question in the cluster must be valid before adding a new question."
      );
      return;
    }

    const newClusters = [...clusters];
    const newQuestion = createEmptyQuestion();
    newClusters[clusterIndex].questions.push(newQuestion);

    const newQuestionIndex = newClusters[clusterIndex].questions.length - 1;
    setClusters(newClusters);
    setSelectedClusterIndex(clusterIndex);

    // const absoluteQuestionIndex = getAbsoluteQuestionNumber(
    //   clusterIndex,
    //   newQuestionIndex
    // );
    setSelectedQuestionIndex(newQuestionIndex);

    // const observer = new MutationObserver((mutationsList, observer) => {
    //   // const newQuestionElement = document.getElementById(
    //   //   `question-editor-${absoluteQuestionIndex}`
    //   // );
    //   // if (newQuestionElement) {
    //   //   observer.disconnect();
    //   //   newQuestionElement.scrollIntoView({
    //   //     behavior: "smooth",
    //   //     block: "start",
    //   //   });
    //   // }
    // });

    // observer.observe(document.body, {
    //   childList: true,
    //   subtree: true,
    // });

    // setTimeout(() => {
    //   const previewElements = Array.from(
    //     document.querySelectorAll(".preview-question-box")
    //   );

    //   const selectedQuestionElement =
    //     previewElements[selectedQuestionIndex - 1];
    //   // if (selectedQuestionElement) {
    //   //   selectedQuestionElement.scrollIntoView({
    //   //     behavior: "smooth",
    //   //     block: "start",
    //   //   });
    //   // }
    // }, 200);
  };

  // const getValidQuestionsCount = (questions: Question[]) => {
  //   return questions.filter(
  //     (q) => q.text.trim() || q.options.some((opt) => opt.trim())
  //   ).length;
  // };

  const examsData = useAppSelecter((state: ObjectValues) => state.exams);

  const clustersRef = useRef(clusters);

  useEffect(() => {
    clustersRef.current = clusters;
  }, [clusters]);

  const [snackbarState, setSnackbarState] = useState<snackbarProps>({
    open: false,
    message: "",
    severity: "info",
  });
  const [err, setErr] = useState<snackbarProps>({
    open: false,
    message: "",
    severity: "info",
  });

  const handleSubmit = async () => {
    setIsLoading(true); // Start loading

    const currentClusters = clustersRef.current;
    const payload: Record<string, any> = {};
    const question_data: Record<string, any> = {};
    const syllabus_data: Record<string, any> = {
      goal_id: examsData.exams_structure.child.selected_row.id,
      mock_section_id:section? section.id:"",
      hindi_translation: hindiTranslation,
    };

    currentClusters.forEach((cluster) => {
      const clusterName = `${cluster.name}`;

      question_data[clusterName] = cluster.questions.map((question) => ({
        question: question.questionHtml,
        option1: question.options[0] || "",
        option2: question.options[1] || "",
        option3: question.options[2] || "",
        option4: question.options[3] || "",
        correct_answer: `option${(question.correctAnswer ?? 0) + 1}`,
        solution: question.solutionHtml || "",
        tag: question.tag
          ? question.tag.split(",").map((tag) => tag.trim())
          : [],
      }));
    });
    syllabus_data["question_in_separate_cluster"] =
      isSingleQuestionPerCluster();
    if (times.min) {
      syllabus_data["min_time"] = times.min;
    }
    if (times.max) {
      syllabus_data["max_time"] = times.max;
    }
    payload["question_data"] = question_data;
    payload["syllabus_data"] = syllabus_data;

    try {
      const res = await apiRequest({
        method: "POST",
        api: allApis.mock_add_bulkquestions,
        payload: payload,
      });

      if (res.success) {
        setSnackbarState({
          open: true,
          message: "Questions added successfully!",
          severity: "success",
        });
        // handleClose();
      } else {
        setSnackbarState({
          open: true,
          message: res.message || "Failed to add questions. Please try again.",
          severity: "error",
        });
      }
    } catch (error) {
      setSnackbarState({
        open: true,
        message: "An error occurred while adding questions. Please try again.",
        severity: "error",
      });
    } finally {
      setIsLoading(false);
    }
  };
  const handleerrClose = () => {
    setErr((prev) => ({
      ...prev,
      open: false,
    }));
  };

  const handleSnackbarClose = () => {
    setSnackbarState((prev) => ({
      ...prev,
      open: false,
    }));
    onClose();
  };

  dialogRef.current = {
    onSubmitForm: handleSubmit,
  };

  const updateQuestion = (
    clusterIndex: number,
    questionIndex: number,
    updatedQuestion: Question
  ) => {
    const newClusters = [...clusters];
    const getClusterRelativeQuestionIndex = (
      clusterIndex: number,
      overallQuestionIndex: number
    ) => {
      const previousValidQuestions = clusters
        .slice(0, clusterIndex)
        .reduce((sum, cluster) => {
          return (
            sum +
            cluster.questions.filter(
              (q) => q.text.trim() || q.options.some((opt) => opt.trim())
            ).length
          );
        }, 0);

      return overallQuestionIndex - previousValidQuestions;
    };

    newClusters[clusterIndex].questions[
      getClusterRelativeQuestionIndex(clusterIndex, questionIndex)
    ] = updatedQuestion;
    setClusters([...newClusters]);
  };

  const getAbsoluteQuestionNumber = (
    clusterIndex: number,
    questionIndex: number
  ) => {
    const previousValidQuestions = clusters
      .slice(0, clusterIndex)
      .reduce((sum, cluster) => {
        return (
          sum +
          cluster.questions.filter(
            (q) => q.text.trim() || q.options.some((opt) => opt.trim())
          ).length
        );
      }, 0);

    const currentClusterQuestions = questionIndex + 1;

    return previousValidQuestions + currentClusterQuestions;
  };

  // useEffect(() => {
  //   const elements = document.querySelectorAll('[id^="question-editor-"]');
  //   setEditorElements(elements);
  // }, [selectedClusterIndex, selectedQuestionIndex, clusters]);

  const handleQuestionSelect = (
    clusterIndex: number,
    questionIndex: number
  ) => {
    setSelectedClusterIndex(clusterIndex);
    setSelectedQuestionIndex(questionIndex);

    // Scroll to the correct editor element in the current cluster
    // setTimeout(() => {
    //   const targetEditor = document.getElementById(
    //     `question-editor-${questionIndex + 1}`
    //   );

    //   if (targetEditor) {
    //     targetEditor.scrollIntoView({
    //       behavior: "smooth",
    //       block: "start",
    //     });
    //   }
    // }, 500);

    // Scroll preview panel
    // setTimeout(() => {
    //   const previewElements = Array.from(
    //     document.querySelectorAll(".preview-question-box")
    //   );

    //   const selectedQuestionElement = previewElements[questionIndex];
    //   if (selectedQuestionElement) {
    //     selectedQuestionElement.scrollIntoView({
    //       behavior: "smooth",
    //       block: "start",
    //     });
    //   }
    // }, 200);
  };

  // useEffect(() => {
  //   if (ref.current) {
  //     // const images = ref.current.querySelectorAll("img");
  //   }
  // }, []);

  useEffect(() => {
    setInterval(mathFunction, 1000);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const allQuestions = clusters.flatMap((cluster, cidx) =>
    cluster?.questions.map((question, index) => ({
      question,
      cidx,
      index,
      absoluteIndex: getAbsoluteQuestionIndex(cidx, index),
    }))
  );
  const allQuestionsPreview = clusters.flatMap((cluster, cidx) =>
    cluster?.questions
      .filter(
        (question) =>
          question.text.trim() && question.options.some((opt) => opt)
      )
      .map((question, index) => ({
        question,
        cidx,
        index,
        absoluteIndex: getAbsoluteQuestionIndex(cidx, index),
      }))
  );

  // Show only the selected question
  const current = allQuestions[selectedQuestionIndex];
  const currentPreview = allQuestionsPreview[selectedQuestionIndex];
  return (
    <>
      {isLoading && <FullScreenLoader open={isLoading} />}
      <Box sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
        {/* Header */}
        <Box sx={{ p: 2, borderBottom: "1px solid #e0e0e0" }}>
          <Breadcrumbs >
                          <CustomBreadcrumbsForMock  />
{ iconText({
            key:`${section?.name??"Section"}`,
            // iconsx:"2px",
            // iconsx:!last&&{marginBottom:"4px"},
            text: `${section?.name??"Section"}`,
            sx: {
              color: globalColors.primary.normalText,
              // first ? globalColors.primary.purple :
            },
            size:"0.75rem",
            onClick:()=>{},
            classname: "",
          })}
          
          { iconText({
            key:`"Section"`,
            // iconsx:"2px",
            // iconsx:!last&&{marginBottom:"4px"},
            text: `Question Bulk Upload`,
            sx: {
              color: globalColors.primary.normalText,
              // first ? globalColors.primary.purple :
            },
            size:"0.75rem",
            onClick:()=>{},
            classname: "",
          })}
          </Breadcrumbs>
        </Box>
        <Box sx={{ flex: 1, display: "flex", overflow: "hidden" }}>
          {/* Left Panel - Questions List */}
          <Paper
            sx={{
              width: 400,
              overflow: "auto",
              borderRight: 1,
              borderColor: "divider",
            }}
          >
            <List>
              {/* Add the stepper wizard at the top */}
              <BulkQuestionsFormStepper
                hindiTranslation={hindiTranslation}
                noClusterType={true}
                setHindiTranslation={setHindiTranslation}
                clusterType={clusterType}
                handleClusterTypeChange={handleClusterTypeChange}
                fileInputRef={fileInputRef}
                currentFileName={currentFileName}
                isUploading={isUploading}
                uploadProgress={uploadProgress}
                hasFileUploaded={hasFileUploaded}
                handleSubmit={handleSubmit}
                isLoading={isLoading}
                setTime={setTime}
                times={times}
                countTotalQuestions={countTotalQuestions}
                isSingleQuestionPerCluster={isSingleQuestionPerCluster}
                handleSeparateQuestions={handleConfirmSingleQuestion}
              />

              {/* Hidden container for rendering docx */}
              <div ref={hiddenContainerRef} style={{ display: "none" }} />
              {/* Hidden file input */}
              <input
                type="file"
                accept=".doc,.docx,.txt,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                id="upload-word-file"
                ref={fileInputRef}
                style={{ display: "none" }}
                onChange={(e) => handleFileUpload(e, selectedClusterIndex)}
              />
              {clusters.map((cluster, clusterIndex) => (
                <React.Fragment key={cluster.id}>
                  <ListItem
                    sx={{
                      backgroundColor:
                        selectedClusterIndex === clusterIndex
                          ? "rgba(25, 118, 210, 0.08)"
                          : "transparent",
                    }}
                  >
                    <ListItemText
                      primary={
                        <Stack
                          direction="row"
                          justifyContent="space-between"
                          alignItems="center"
                        >
                          <Typography sx={{ fontWeight: "bold" }}>
                            {cluster.name}
                          </Typography>
                          <Typography
                            variant="caption"
                            sx={{
                              backgroundColor: "primary.main",
                              color: "white",
                              borderRadius: "12px",
                              px: 1,
                              py: 0.5,
                            }}
                          >
                            {cluster.questions.filter(isValidQuestion).length}{" "}
                            {cluster.questions.filter(isValidQuestion)
                              .length === 1
                              ? "Question"
                              : "Questions"}
                          </Typography>
                        </Stack>
                      }
                    />
                  </ListItem>
                  {cluster.questions
                    // .filter(isValidQuestion)
                    .map((question, questionIndex) => (
                      <ListItem
                        key={question.id}
                        button
                        selected={
                          selectedClusterIndex === clusterIndex &&
                          selectedQuestionIndex ===
                            getAbsoluteQuestionNumber(
                              clusterIndex,
                              questionIndex
                            ) -
                              1
                        }
                        onClick={() =>
                          handleQuestionSelect(
                            clusterIndex,
                            getAbsoluteQuestionNumber(
                              clusterIndex,
                              questionIndex
                            ) - 1
                          )
                        }
                        sx={{
                          pl: 4,
                          "&.Mui-selected": {
                            backgroundColor: "lightgrey",
                          },
                          "&:hover": {
                            backgroundColor: "grey",
                          },
                        }}
                      >
                        <ListItemText
                          primary={
                            <Box sx={{ display: "flex", gap: 1 }}>
                              <span>{`Q${getAbsoluteQuestionNumber(
                                clusterIndex,
                                questionIndex
                              )}.`}</span>
                              {/* <span
                                dangerouslySetInnerHTML={{
                                  __html: `${
                                    question.questionHtml.slice(0, 30) ||
                                    `Question ${questionIndex + 1}`
                                  }${question.text.length > 30 ? "..." : ""}`,
                                }}
                              /> */}
                            </Box>
                          }
                        />
                      </ListItem>
                    ))}
                  <Divider />
                </React.Fragment>
              ))}
            </List>
          </Paper>

          {/* Center Panel - Editor */}
          <Box
            sx={{
              flex: 1,
              overflow: "auto",
              bgcolor: "background.default",
              p: 3,
            }}
            onPaste={handleSmartPaste}
          >
            {current && (
              <QuestionEditor
                key={current.question.id}
                question={current.question}
                questionNumber={current.absoluteIndex}
                onQuestionChange={(updatedQuestion) =>
                  updateQuestion(
                    current.cidx,
                    selectedQuestionIndex,
                    updatedQuestion
                  )
                }
                fileInputRef={fileInputRef}
                isSelected={true}
              />
            )}
          </Box>

          {/* Right Panel - Stepper and Preview */}
          <Paper
            sx={{
              width: 480,
              overflow: "auto",
              borderLeft: 1,
              borderColor: "divider",
              display: "flex",
              flexDirection: "column",
            }}
          >
            {/* Preview section */}
            {hasFileUploaded && (
              <Box sx={{ p: 3 }}>
                <Typography variant="h6" gutterBottom>
                  Question Preview
                </Typography>
                <Box ref={ref} sx={{ overflow: "auto" }}>
                  {currentPreview && (
                    <QuestionPreview
                      key={currentPreview.question.id}
                      question={currentPreview.question}
                      questionNumber={currentPreview.absoluteIndex}
                      isSelected={true}
                      onClick={() =>
                        setSelectedQuestionIndex(selectedQuestionIndex)
                      }
                    />
                  )}
                </Box>
              </Box>
            )}
          </Paper>
        </Box>
        {/* Footer */}
        <Box
          sx={{
            p: 2,
            borderTop: 1,
            borderColor: "divider",
            bgcolor: "background.paper",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              p: 2,
            }}
          >
            <Box>
              <Button variant="outlined" onClick={onClose}>
                Cancel
              </Button>
            </Box>
            {/* <Box sx={{ display: "flex", gap: 2 }}>
              <Button
                variant="outlined"
                startIcon={<AddIcon />}
                onClick={() => addNewQuestion(selectedClusterIndex)}
              >
                Add Question to {clusters[selectedClusterIndex]?.name}
              </Button>
              <Button
                variant="outlined"
                startIcon={<AddIcon />}
                onClick={addNewCluster}
              >
                Add New Cluster
              </Button>
            </Box> */}
          </Box>
        </Box>
        <CustomSnackbar
          open={snackbarState.open}
          message={snackbarState.message}
          severity={snackbarState.severity}
          onClose={handleSnackbarClose}
        />{" "}
        <CustomSnackbar
          open={err.open}
          message={err.message}
          severity={err.severity}
          onClose={handleerrClose}
        />
      </Box>
    </>
  );
}
